import type { AreaTreeNode, KnowledgeArea } from '../pages/knowledge/knowledgeTypes'
import { apiClient } from './client'

export interface CreateAreaBody {
  name: string
  parentId?: number | null
  areaType?: string
  description?: string | null
  aliases?: string[]
}

export interface UpdateAreaBody {
  name?: string
  description?: string | null
  aliases?: string[]
  areaType?: string
  status?: string
  position?: number
}

export const knowledgeApi = {
  listAreas: (projectId: number) =>
    apiClient.get<{ areas: KnowledgeArea[]; tree: AreaTreeNode[] }>(
      `/projects/${projectId}/knowledge/areas`
    ),

  createArea: (projectId: number, body: CreateAreaBody) =>
    apiClient.post<{ area: KnowledgeArea }>(`/projects/${projectId}/knowledge/areas`, body),

  updateArea: (projectId: number, areaId: number, patch: UpdateAreaBody) =>
    apiClient.patch<{ area: KnowledgeArea }>(
      `/projects/${projectId}/knowledge/areas/${areaId}`,
      patch
    ),

  moveArea: (
    projectId: number,
    areaId: number,
    body: { newParentId: number | null; position?: number }
  ) =>
    apiClient.post<{ area: KnowledgeArea }>(
      `/projects/${projectId}/knowledge/areas/${areaId}/move`,
      body
    ),

  mergeArea: (projectId: number, areaId: number, intoAreaId: number) =>
    apiClient.post<void>(`/projects/${projectId}/knowledge/areas/${areaId}/merge`, { intoAreaId }),

  deleteArea: (projectId: number, areaId: number) =>
    apiClient.delete<void>(`/projects/${projectId}/knowledge/areas/${areaId}`),
}
